import { render, staticRenderFns } from "./AgencyForm.vue?vue&type=template&id=0b540461&scoped=true"
import script from "./AgencyForm.vue?vue&type=script&lang=ts"
export * from "./AgencyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b540461",
  null
  
)

export default component.exports